import { render, staticRenderFns } from "./FieldPhonemes.vue?vue&type=template&id=1614435f&"
import script from "./FieldPhonemes.vue?vue&type=script&lang=ts&"
export * from "./FieldPhonemes.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports